import React from 'react';
import * as S from './timeline-segment.styles';

interface ITimelineSegmentProps {
    start?: boolean;
}

export const TimelineSegment: React.FC<ITimelineSegmentProps> = ({ start }) => (
    <S.Wrapper>
        <S.TimelineDot $isFirst={!!start} />
    </S.Wrapper>
);
